import { render, staticRenderFns } from "./ShopStoreTakeoutOrder.vue?vue&type=template&id=72793783&scoped=true&"
import script from "./ShopStoreTakeoutOrder.vue?vue&type=script&lang=js&"
export * from "./ShopStoreTakeoutOrder.vue?vue&type=script&lang=js&"
import style0 from "./ShopStoreTakeoutOrder.vue?vue&type=style&index=0&id=72793783&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72793783",
  null
  
)

export default component.exports